var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08809 10.2C5.08809 10.344 5.18409 10.44 5.32809 10.44H6.67209C6.81609 10.44 6.91209 10.344 6.91209 10.2V6.408C6.91209 6.312 6.96009 6.264 7.05609 6.264H10.8001C10.9441 6.264 11.0401 6.168 11.0401 6.024V4.728C11.0401 4.584 10.9441 4.488 10.8001 4.488H7.05609C6.96009 4.488 6.91209 4.44 6.91209 4.344V0.551999C6.91209 0.408 6.81609 0.312 6.67209 0.312H5.32809C5.18409 0.312 5.08809 0.408 5.08809 0.551999V4.344C5.08809 4.44 5.04009 4.488 4.94409 4.488H1.20009C1.05609 4.488 0.960094 4.584 0.960094 4.728V6.024C0.960094 6.168 1.05609 6.264 1.20009 6.264H4.94409C5.04009 6.264 5.08809 6.312 5.08809 6.408V10.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0122ef09f2df3f1f4800293157f2e086.svg";
export { ForwardRef as ReactComponent };